import { render } from "./ErrorLayout.vue?vue&type=template&id=508a1b74&scoped=true"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"

import "./ErrorLayout.vue?vue&type=style&index=0&id=508a1b74&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508a1b74"]])

export default __exports__